<template>
  <span
    v-tooltip="{
      content: tooltip ?? $t('COMMON.COPY_TO_CLIPBOARD'),
      onShow: () => showTooltip,
    }"
    class="copy-button flex h-min w-min cursor-pointer items-center justify-center rounded-sm hover:bg-grey-hover"
    :class="{ 'h-6 w-6': size === 'sm' }"
    data-cy="copy-record-button"
    @click="copy"
  >
    <icon-base
      class="text-label"
      :icon="icon"
      fill="#868D9C"
      :view-box="ICON_VIEWBOXES[icon]"
      :height="iconSize"
      :width="iconSize"
    />
  </span>
</template>
<script lang="ts">
import { computed } from "vue";

import { useClipboardWithMessage } from "@/hooks/clipboard";
</script>
<script setup lang="ts">
const {
  value,
  tooltip,
  icon = "copy",
  showTooltip = true,
  size = "md",
} = defineProps<{
  value: string | number;
  tooltip?: string;
  icon?: "copy" | "link";
  showTooltip?: boolean;
  size?: "sm" | "md";
}>();

const ICON_VIEWBOXES = {
  copy: "0 0 20 20",
  link: "0 0 24 24",
};
const copyToClipboard = useClipboardWithMessage();

const iconSize = computed(() => (size === "md" ? 20 : 16));
const copy = async () => {
  await copyToClipboard(value);
};
</script>
